import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import Table from "../../../components/Tables/ExpandedTable";
import { headerMaker } from "../../../components/Tables/ExpandedTable/helper";
import { productsHeader } from "../../../redux/modules/table/common";
import { useDispatch, useSelector } from "react-redux";
import reports from "../../../services/reports";
import rateType from "../../../services/ratingtype";
import Spinner from "../../../components/Spinner";

import { setReportSubData } from "../../../redux/modules/application/actions";
import { makeReport } from "../../../utils/makeReport";
import { groupHeaders } from "../../../utils/groupHeader";
import { useShowModal } from "../../../hooks";
import works from "../../../services/works";
import { workConstructor } from "../../../utils/workConstructor";
import { Col, Pagination, Row } from "antd";
import { setPage, clearState } from "../../../redux/modules/modalwork/actions";
import { setModalLoading } from "../../../redux/modules/modals/actions";
import RatedWork from "../../../components/Cards/TaskCard";
import DatePicker from "../../../components/DatePicker";
import Select from "../../../components/FormElements/Select";
import { usePaginate } from "hooks/usePaginate";

export default () => {
  const { showBlured } = useShowModal();
  const { page, modalWork } = useSelector((state) => state.modalWork);
  const dispatch = useDispatch();
  const [placeList, setPlaceList] = useState([]);

  const { singleDate } = useSelector((state) => state.selectedDateReducer);
  const [group, setGroup] = useState("");
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { data, handleOnTableChange, pageCount } = usePaginate();
  const { constructorMethod } = workConstructor();
  const [reportsData, setReportsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSub, setLoadingSub] = useState(false);
  // const [pageCount, setPageCount] = useState(0);
  // const fetchIdRef = useRef(0);
  // const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [newHeader, setNewHeader] = useState([]);

  useEffect(() => {
    const foo = headerMaker(productsHeader.concat(groupHeaders(newHeader)));
    setHeaders(foo);
  }, [newHeader]);

  const fetchRateReports = async () => {
    try {
      setLoading(true);
      const data = {
        date: singleDate,
        group,
      };
      const reportData = await reports.getAllDaiyReport(data);
      const ratesType = await rateType.getAll();
      const myCat = reportData[0]?.categorys.map((i) => i.category);
      setNewHeader(categories.filter((i) => myCat.includes(i._id)));
      const report = makeReport(
        reportData,
        regions,
        groups,
        categories,
        users,
        ratesType
      );
      setReportsData(report.sort((a, b) => b.total.value - a.total.value));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    setGroup(groups[0]?._id);
  }, [groups]);

  useEffect(() => {
    if (singleDate && group !== "") {
      fetchRateReports();
    }
  }, [categories, regions, groups, singleDate, group]);

  const handleSelectgroup = async (id, userId) => {
    try {
      setLoadingSub(true);
      const data = {
        date: singleDate,
        category: id,
        user: userId,
        group,
      };
      const resp = await reports.getAllDaiyReport(data);
      const subCats = categories.filter((item) => item.parent === id);
      const report = subCats.map((item, idx) => {
        const subCat = resp.find((itm) => itm.subCategory === item._id);
        return {
          id: idx + 1,
          name: item?.title,
          subCategoryId: item?._id,
          total: subCat?.rate
            ? Math.min(Math.round(subCat?.rate), 100)
            : subCat?.rate,
          categoryId: id,
          user: userId,
          groupId: group,

          // regionId: regionId,
        };
      });

      dispatch(setReportSubData(report ? report : []));
      setLoadingSub(false);
    } catch (error) {
      setLoadingSub(false);
      console.log(error);
    }
  };

  const onChangePage = (p) => {
    dispatch(setPage(p));
  };

  useEffect(() => {
    if (page > 0) {
      setWorksModal();
    }
    // return () => dispatch(clearState());
  }, [page]);

  const setWorksModal = async (data) => {
    dispatch(setModalLoading(true));
    try {
      const reqData = {
        startDate: singleDate,
        endDate: singleDate,
        user: modalWork?.user ? modalWork?.user : data?.user,
        group: modalWork?.groupId ? modalWork?.groupId : data?.groupId,
        subCategory: modalWork?.subCategoryId
          ? modalWork?.subCategoryId
          : data?.subCategoryId,
        page: page === 0 ? 1 : page,
        limit: 1,
        status: 3,
      };
      const common = { categories, regions, groups, users };
      const resp = await works.getAll(reqData);
      const workerData = constructorMethod(resp.docs, common);
      dispatch(setModalLoading(false));
      showBlured({
        title: "Батафсил",
        maxWidth: "90vw",
        maxHeight: "85vh",
        withHeader: false,
        body: () => (
          <div style={{ padding: "20px", textAlign: "center" }}>
            {workerData?.length > 0 ? (
              <>
                <RatedWork
                  data={workerData[0]}
                  medium
                  borderLess
                  objectsList={placeList}
                />
                <Pagination
                  current={page === 0 ? 1 : page}
                  pageSize={1}
                  onChange={onChangePage}
                  total={resp?.totalPages}
                  // size="large"
                />
              </>
            ) : null}
          </div>
        ),
      });
    } catch (error) {
      console.log(error);
    }
  };

  // const handleTableChange = useCallback(
  //   ({ pageSize, pageIndex }) => {
  //     const fetchId = ++fetchIdRef.current;
  //     if (fetchId === fetchIdRef.current) {
  //       const startRow = pageSize * pageIndex;
  //       const endRow = startRow + pageSize;
  //       const pageData = reportsData.slice(startRow, endRow);
  //       setData(pageData);
  //       setPageCount(Math.ceil(reportsData.length / pageSize));
  //     }
  //   },
  //   [reportsData]
  // );

  if (loading) return <Spinner maxHeight="100%" />;

  return (
    <>
      <Row align="middle" justify="end" gutter={20}>
        <Col>
          <Select
            allowClear={false}
            options={groups}
            defaultVal={group}
            handleChange={(value) => setGroup(value)}
          />
        </Col>
        <Col>
          <div style={{ padding: " 20px 0" }}>
            <DatePicker />
          </div>
        </Col>
      </Row>
      <Table
        headers={headers}
        selectgroup={handleSelectgroup}
        loading={loadingSub}
        setWorksModal={setWorksModal}
        onChange={handleOnTableChange}
        total={reportsData.length}
        data={data}
        reportsData={reportsData}
        page={pageCount}
      />
    </>
  );
};
